export const LISTS = "/api/pa/lists";
export const LIST = "/api/pa/lists/:param";
export const DELETE_LIST = "/api/pa/lists/:param/delete";
